import { ActionModal } from '@atoms/Modals';
import format from 'date-fns/format';
import React from 'react';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

type Columns = {
    label: string;
    key: string;
};

type Props = {
    listData?: any;
};

const openApplyColumn: Columns[] = [
    { label: '契約コード', key: 'contactId' },
    { label: '廃止申請日', key: 'relitRequestDate' },
    { label: 'スイッチング申請日', key: 'relitRequestDate' }
];


const CsvDownloadOpenApply = (props: Props) => {
    const fileNameDate = `swiching_apply_ok_list_${format(new Date(), 'yyyyMMdd_HHmmss')}`;
    const { listData } = props;
    const { data, error, loading } = listData;
    const openRequestListData = data || [];

    return (
        <CsvDownloadWithStyled>
            {loading && '' }
            {error && '' }
            {data &&
                <ActionModal
                    title='再点 申請完了一覧ダウンロード'
                    body='再点 申請完了一覧をダウンロードします。よろしいですか？'
                    buttonText='CSVダウンロード(申請OK)'
                    buttonStyle='btn-primary'
                    element={<CSVLink className='btn btn-primary' filename={fileNameDate} headers={openApplyColumn} data={openRequestListData}>はい</CSVLink> }
                    disabled={!openRequestListData.length}
                />
            }
        </CsvDownloadWithStyled>
    );
};

const CsvDownloadWithStyled = styled.div`
`

export default CsvDownloadOpenApply;